interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <nav aria-label="分页导航" className="flex items-center justify-center gap-2 flex-wrap mt-8">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className="px-3 py-2 rounded-md text-sm font-label border border-background-300 bg-background-50 text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line"></i> 上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`w-10 h-10 rounded-md text-sm font-label transition-colors cursor-pointer ${
            page === currentPage
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 bg-background-50 text-foreground-700 hover:bg-background-100"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className="px-3 py-2 rounded-md text-sm font-label border border-background-300 bg-background-50 text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100 cursor-pointer whitespace-nowrap"
      >
        下一页 <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}